import { ESharedComponent } from '../../UI/State/ESharedComponent';
import { IGoalsContainerState } from '../../../presentation/MainPanel/Goals/IGoalsState';
import { State } from '../../UI/State/State';

export function GetCachedGoals() {
	const goals = State.ReadClass<IGoalsContainerState>(ESharedComponent.GoalsContainer);

	if (goals) {
		return goals.state.Goals;
	}
}
